import React from 'react';
import projImg3 from "../../assets/img/n3.png";
import projectimage3 from "../../assets/img/np3.png";
import ShowMoreText from "react-show-more-text";
import { Card } from 'react-bootstrap';

const Card3 = () => {
    // Your component logic here

    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Tournament Design</h2></Card.Title> */}

        <Card.Img variant="top" src={projectimage3} />

        <Card.Body>
          <Card.Text>
            {" "}
            <img className="img2" src={projImg3} />{" "}
            <p className="text7">Gábor Hellner</p>
            <br />
            <p className="text8">
              Blockchain Expert, CEO
              <br />
              CryptoSoft
            </p>
          </Card.Text>
          <ShowMoreText lines={2}>
            <div>
              The aim of this project is to participate in the analysis of
              cryptocurrency issuances. The task is to mathematically
              analyze cryptocurrency structures and trading transactions
              with Big Data graph algorithms in order to detect anomalies
              and also investigate "customer" habits. The main goal of the
              project is to use machine learning and network algorithms to
              gain a better understanding of customer behavior after the
              issuance of various cryptocurrencies. The data will be
              provided by the supervisor.
              <br />
              <br />
              Related literature:{" "}
              <ul>
                <li>
                  Boreiko, D., & Risteski, D. (2021). Serial and large
                  investors in initial coin offerings.
                  <span className="text9">
                    {" "}
                    Small Business Economics, 57, 1053-1071{" "}
                  </span>
                </li>
                <li>
                  Yousaf, I., & Yarovaya, L. (2022). Herding behavior in
                  conventional cryptocurrency market, non-fungible tokens,
                  and DeFi assets.
                  <span className="text9">
                    {" "}
                    Finance Research Letters, 50, 103299{" "}
                  </span>
                  ,
                </li>
                <li>
                  Zhang, S., Zhang, D., Zheng, J., Aerts, W., & Xu, D.
                  (2023). Plus Token and investor searching behaviour–A
                  cryptocurrency Ponzi scheme.
                  <span className="text9"> Accounting & Finance. </span>,
                </li>
                <li>
                  {" "}
                  Alshater, M. M., Joshipura, M., Khoury, R. E., &
                  Nasrallah, N. (2023). Initial coin offerings: A hybrid
                  empirical review.
                  <span className="text9">
                    Small Business Economics, 1-18.{" "}
                  </span>{" "}
                  ,
                </li>
              </ul>
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Card3;
